module.exports = __webpack_public_path__ + "static/img/mep-bg4.32c3072a.png";